// @flow

import { Component } from 'react';
import ThumbnailWithStatelemsPlaceholderImage from '../thumbnail-with-statelems-placeholder-image';
import { ThumbnailWithLocationNameWithStatelems } from '../../models/query-response';

type Props = {
  thumb: ThumbnailWithLocationNameWithStatelems
};

class ThumbnailWithStatelemsSingleImageDisplayer extends Component<Props> {
  render() {
    const { thumb } = this.props;

    return (
      <ThumbnailWithStatelemsPlaceholderImage thumb={thumb} width="100%" height="auto" />
    );
  }
}

export default ThumbnailWithStatelemsSingleImageDisplayer;
